import { itemRootNode } from "@corca/data/libraries/item";

import type { SuggestionItem, SuggestionNodeType } from "@/components/suggestions/types";
import type { NodeJson } from "@corca/data";

/**
 * The one node a library item inserts, when it inserts exactly one; a multi-root item has none
 * and behaves as an expression.
 */
export function libraryRootNode(item: SuggestionItem): NodeJson | undefined {
  const { nodesJson } = item;
  return item.type === "library" && nodesJson ? itemRootNode({ nodesJson }) : undefined;
}

/**
 * The kind of node a suggestion inserts: the item's type, or the root node's type for a
 * single-root library item, since a library item carries nodes rather than a node type.
 */
export function insertedNodeType(item: SuggestionItem): SuggestionNodeType {
  const root = libraryRootNode(item);
  return root ? (root.type as SuggestionNodeType) : item.type;
}
